<template lang="html">
  <div>
    <teacherHeader/>
    <slot/>
    <teacherFooter/>
    <transition name="show-menu">
      <div class="main__menu" v-if="showMenu">
        <font-awesome-icon class="main__menu__icon" icon="times" @click="setShowMenu(false)"/>
        <ul>
          <li @click="goTo('perfil')">Perfil</li>
          <li @click="logout()">Logout</li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import teacherHeader from '@/components/header/teacher'
import teacherFooter from '@/components/footer'

import appBus from '@/plugins/appBus'

export default {
  name: 'templateTeacher',
  data () {
    return {
      showMenu: false
    }
  },
  methods: {
    setShowMenu (show) {
      this.showMenu = show
    },
    async goTo (route) {
      this.setShowMenu(false)
      await this.$delay(200)
      this.$router.push({ name: route })
    },
    async logout () {
      this.setShowMenu(false)
      await this.$delay(200)
      await this.$store.dispatch('auth/logout')
    }
  },
  components: {
    teacherHeader,
    teacherFooter
  },
  mounted () {
    appBus.$on('showMenu', this.setShowMenu)
  },
  beforeDestroy () {
    appBus.$off('showMenu', this.setShowMenu)
  }
}
</script>

<style media="screen" lang="scss" scoped>
.main__menu {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(30, 0, 0, 0.9);
  width: 100vw;
  height: 100vh;
  z-index: 150;
  display: flex;
  &__icon {
    position: absolute;
    top: 5vh;
    right: 5vw;
    height: 60px;
    width: 60px;
    color: #ff7878;
    transition: transform .2s;
    cursor: pointer;
    &:hover {
      transform: scale(1.2) rotate(90deg);
    }
  }
  ul {
    list-style-type: none;
    margin: 0 auto;
    margin-top: 25vh;
    text-align: center;
    li {
      transition: transform .2s;
      font-size: 35px;
      font-weight: 300;
      letter-spacing: 1px;
      color: #CCC;
      cursor: pointer;
      &:hover {
        transform: scale(1.2) translateY(-10px);
      }
    }
  }
}

.show-menu {
  &-enter-active {
    animation: opaque .2s ease backwards;
    animation-delay: .2s;
  }
  &-leave-active {
    animation: opaque .2s ease reverse backwards;
  }
}

@keyframes opaque {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>



// WEBPACK FOOTER //
// src/components/template/teacher.vue